import { FC, useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import CustomButton from 'shared/components/customButton/customButton';
import { Beginners } from 'shared/components/icons/icons';
import Modal from 'shared/components/modal/modal';
import { notify } from 'shared/components/notification/notification';
import { Translate } from 'shared/components/translate/translate';
import { IState } from 'shared/interface/state';
import localizationConstants from 'shared/util/translation/constant';
import { copyToClipboard, isWhiteLabel } from 'shared/util/utility';
const isLotteryVersion = process.env['REACT_APP_IS_LOTTERY_VERSION'];

interface IInviteFriend {
	handleClose: () => void;
}

const InviteFriend: FC<IInviteFriend> = ({ handleClose }) => {
	const { t } = useTranslation();
	const subTitle = isLotteryVersion ? '' : localizationConstants.inviteFriendsSubTitle;
	const userName = useSelector((state: IState) => state.auth.profileData.userName);
	const [loading, setLoading] = useState<boolean>(false);

	const handleCopyLink = useCallback(() => {
		setLoading(true);
		try {
			copyToClipboard(`${window.location.origin}/register/refer/${userName}`);
			setTimeout(() => {
				setLoading(false);
			}, 500);
			notify(t(localizationConstants.copyClipboard), 'success');
		} catch (error) {
			setLoading(false);
			notify(t(localizationConstants.failCopy), 'error');
		}
	}, [t, userName]);

	return (
		<Modal
			title={t(localizationConstants.inviteFriends)}
			subTitle={t(subTitle)}
			closeModal={handleClose}
			isFooter={false}
			className='invite-friend-modal text--center'
		>
			<div>
				{isLotteryVersion ? (
					<div className='mb--35'>
						<Beginners />
					</div>
				) : (
					<div className='flex justify-content--center font-size--lg font--bold mb--35'>
						<div className='amount-tab text-gradient-red'>€150</div>
					</div>
				)}
				<p className='font-size--lg font--bold mb--10'>
					{!isWhiteLabel && '1.'} <Translate text={localizationConstants.inviteYourFriends} />
				</p>
				<p className='font-size--sm mb--20'>
					<Translate text={localizationConstants.shareInvitationLink} />
				</p>
				{!isWhiteLabel && (
					<>
						{isLotteryVersion ? (
							<div>
								<p className='font-size--lg font--bold mb--10'>
									2. <Translate text={localizationConstants.challengeFriend} />
								</p>
								<p className='font-size--sm mb--20'>
									<Translate text={localizationConstants.takePart} />
								</p>
							</div>
						) : (
							<div>
								<p className='font-size--lg font--bold mb--10'>
									2. <Translate text={localizationConstants.friendRegister} />
								</p>
								<p className='font-size--sm mb--20'>
									<Translate text={localizationConstants.friendRegisterAndDeposit} />
								</p>
								<p className='font-size--lg font--bold mb--10'>
									3. <Translate text={localizationConstants.challengeFriend} />
								</p>
								<p className='font-size--sm mb--20'>
									<Translate text={localizationConstants.takePart} />
								</p>
							</div>
						)}
					</>
				)}
				<CustomButton
					buttonTitle={t(localizationConstants.inviteFriendsNow)}
					btnClassName='primary-button mb--20'
					isSubmitLoading={loading}
					onButtonClick={handleCopyLink}
				/>
			</div>
		</Modal>
	);
};

export default InviteFriend;
